import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const tabs = [
  { label: 'Overview', path: '/' },
  { label: 'Engagement', path: '/dashboard/engagement' },
  { label: 'AEO', path: '/dashboard/aeo' },
];

/**
 * Top-right tab navigation shared by all three dashboard views:
 * Overview · Engagement · AEO
 *
 * Self-manages its positioning:
 * - Normally: absolute top-0 right-0 (floats over dashboard content)
 * - On /dashboard/aeo: normal flow (flex justify-end)
 */
const DashboardTabNav: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isAEO = pathname === '/dashboard/aeo';

  const isActive = (path: string) =>
    path === '/' ? pathname === '/' : pathname.startsWith(path);

  const isAbsolute = !isAEO;

  return (
    <div className={isAbsolute ? 'absolute top-0 right-0 z-10' : 'flex justify-end z-10'}>
      <div className="inline-flex items-center gap-2 bg-gray-100 p-1 rounded-md">
        {tabs.map((tab) => (
          <button
            key={tab.path}
            type="button"
            onClick={() => navigate(tab.path)}
            className={`text-sm font-medium transition-all duration-500 ${isActive(tab.path)
              ? 'text-indigo-600 bg-white rounded-md p-2 py-1'
              : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md p-2 py-1'
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DashboardTabNav;
